import type { TrpcRouter } from "@scale-lti/api/src/trpc/router.js";
import { createTRPCReact } from "@trpc/react-query";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";

export type TrpcInput = inferRouterInputs<TrpcRouter>;
export type TrpcOutput = inferRouterOutputs<TrpcRouter>;

const trpc = createTRPCReact<TrpcRouter>();

export default trpc;
export type { TrpcRouter };
